import { render, staticRenderFns } from "./input-birth.vue?vue&type=template&id=425c7aa4&"
import script from "./input-birth.vue?vue&type=script&lang=js&"
export * from "./input-birth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports